import React from 'react';

const Youtubehome = () => {
  return (
    <>
      <section style={{ padding: '50px 20px', backgroundColor: '#f4f4f4' }}>
        <div className="container">
          <h2 className='text-center' style={{ marginBottom: '40px', fontSize: '2.5rem', fontWeight: '600', color: '#333' }}>
            Our Featured Videos
          </h2>
          
          <div className='row g-4'>

            {/* First video */}
            <div className='col-12 col-md-6'>
              <div className="youtube-embed">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/1BBc5QHVZYI?si=gIVC3SptRcK93TMZ&loop=1&playlist=1BBc5QHVZYI"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{ borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                ></iframe>
              </div>
            </div>

            {/* Second video */}
            <div className='col-12 col-md-6'>
              <div className="youtube-embed">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/O_663Z5dKlo?si=gpTZxoXlyl3VhViA&loop=1&playlist=O_663Z5dKlo"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{ borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                ></iframe>
              </div>
            </div>

            {/* Third video */}
            {/* <div className='col-12 col-md-4'>
              <div className="youtube-embed">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/kgY2OyYE4D4?si=lMxXvKi1G31CsEFb&loop=1&playlist=kgY2OyYE4D4"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  style={{ borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                ></iframe>
              </div>
            </div> */}

          </div>
        </div>
      </section>
    </>
  );
};

export default Youtubehome;
